import script from "./SearchPatient.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchPatient.vue?vue&type=script&setup=true&lang=js"

import "./SearchPatient.vue?vue&type=style&index=0&id=02277eaa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02277eaa"]])

export default __exports__